import axios from 'axios';
import { store } from '../store';

export function loadThreeWayCalls(agent_username, params = {}) {
  const { token } = store.getState().auth;
  const {
    stCallID,
    stCallStartDate,
    stCallEndDate,
    stClientFirstName,
    stClientLastName,
    stClientPhone,
  } = store.getState().threeWay;
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/call/`,
      headers: { Authorization: `Token ${token}` },
      params: {
        agent: agent_username,
        call_id: stCallID || null,
        call_start_max: stCallEndDate || null,
        call_start_min: stCallStartDate || null,
        shopper_first_name: stClientFirstName || null,
        shopper_last_name: stClientLastName || null,
        shopper_phone: stClientPhone || null,
        ...params,
      },
    }).then(({ data = {} }) => {
      resolve(data);
    }).catch(err => {
      reject(err);
    });
  });
}

export function updateThreeWayCall(callData) {
  const { token } = store.getState().auth;
  const { call_id } = callData;
  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/call/${call_id}/`,
      headers: { Authorization: `Token ${token}` },
      data: callData,
    }).then(({ data = {} }) => {
      resolve(data);
    }).catch(err => {
      reject(err);
    });
  });
}
